import { useTranslation } from 'react-i18next';
import { TrendingUp } from 'lucide-react';

// Pass 29, Phase 2: the direct, honest UI expression of the confidence
// shrinkage curve (CONFIDENCE_SHRINKAGE_K=15 in credibility_service.py) --
// under 15 resolved predictions, a user's score is still being meaningfully
// discounted toward a neutral prior by the formula itself. This badge says
// so out loud rather than showing a confident-looking number that doesn't
// yet deserve full confidence, the same "transparency" input the
// Credibility Protocol already claims to have.
const CONFIDENCE_SHRINKAGE_K = 15;

export default function BuildingTrackRecordBadge({ totalPredictions, size = 'default' }) {
  const { t } = useTranslation();
  if (totalPredictions == null || totalPredictions >= CONFIDENCE_SHRINKAGE_K) return null;

  const sizeClasses = size === 'sm'
    ? 'text-[10px] px-2 py-0.5 gap-1'
    : 'text-sm px-3 py-1 gap-2';

  return (
    <div
      className={`inline-flex items-center text-indigo-600 dark:text-indigo-300 bg-indigo-100 dark:bg-indigo-500/10 rounded-full border border-indigo-500/20 whitespace-nowrap ${sizeClasses}`}
      title={t('profileWidgets.trackRecordBadge.tooltip', { count: totalPredictions, needed: CONFIDENCE_SHRINKAGE_K })}
    >
      <TrendingUp className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />
      <span>{t('profileWidgets.trackRecordBadge.label')}</span>
    </div>
  );
}
